import React from "react";
import { useTranslation } from "react-i18next";

// Matches Diamond-PO-Prototype-v3.html's stoneTitle()/tags()/reportOf() exactly (lines 565-566,
// 672-673). `snap` is a parsed StoneSnapshotJson -- same field names end to end (shape, caratT,
// color, clarity, lab, certNo, stockNo, origin, isLab, type, stones).

const tagStyle = { fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 4, letterSpacing: ".03em", whiteSpace: "nowrap" };
const labStyle = { ...tagStyle, background: "#e9f7f4", color: "#0f766e", border: "1px solid #b9e4dc" };
const natStyle = { ...tagStyle, background: "#fdf7e8", color: "#8a6a14", border: "1px solid #ecdcae" };
const pairStyle = { ...tagStyle, background: "#f0ebfb", color: "#5b45a8", border: "1px solid #ddc9f5" };
const parcelStyle = { ...tagStyle, background: "#fff1e0", color: "#a3701a", border: "1px solid #f5d9ac" };
const subStyle = { fontSize: 12, color: "#79838f", marginTop: 1 };

export const StoneSummary = ({ snap, note }) => {
  const { t } = useTranslation();
  if (!snap) return null;
  const caratT = Number(snap.caratT || 0);
  const carat = (caratT / 1000).toFixed(3).replace(/0+$/, "").replace(/\.$/, ".000");
  return (
    <div>
      <div>
        <b>
          {carat} {t("ct")} {snap.shape} {snap.color} {snap.clarity}
        </b>{" "}
        <span style={snap.isLab ? labStyle : natStyle}>{snap.isLab ? t("LAB-GROWN") : t("NATURAL")}</span>{" "}
        {snap.type === "pair" && <span style={pairStyle}>{t("MATCHED PAIR")}</span>}
        {snap.type === "parcel" && (
          <span style={parcelStyle}>
            {t("PARCEL")} · {snap.stones} {t("stones")}
          </span>
        )}
      </div>
      <div style={subStyle}>
        {snap.lab === "None" ? `${t("Stock")} ${snap.stockNo}` : `${snap.lab} ${snap.certNo}`} · {snap.origin}
      </div>
      {note && (
        <div style={{ ...subStyle, color: "#e2574c" }}>
          ⚠ {note}
        </div>
      )}
    </div>
  );
};

export default StoneSummary;
